var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVector(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.00586 0C1.04086 0 0.255859 0.785 0.255859 1.75C0.255859 2.54 0.785859 3.2015 1.50586 3.4185V6.9985C1.50536 7.088 1.51936 7.889 2.09286 8.464C2.44686 8.82 2.92086 9 3.50086 9V10L5.50086 8.5L3.50086 7V8C2.58936 8 2.50886 7.233 2.50586 7V3.4185C3.22586 3.2015 3.75586 2.54 3.75586 1.75C3.75586 0.785 2.97036 0 2.00586 0ZM2.00586 2.5C1.59236 2.5 1.25586 2.1635 1.25586 1.75C1.25586 1.3365 1.59236 1 2.00586 1C2.41936 1 2.75586 1.3365 2.75586 1.75C2.75586 2.1635 2.41936 2.5 2.00586 2.5ZM8.50586 6.5815V2.9985C8.50336 2.1955 7.96736 1 6.50086 1V0L4.50086 1.5L6.50086 3V2C7.41536 2 7.50136 2.7695 7.50586 3V6.5815C6.78586 6.7985 6.25586 7.46 6.25586 8.25C6.25586 9.215 7.04086 10 8.00586 10C8.97086 10 9.75586 9.215 9.75586 8.25C9.75586 7.46 9.22586 6.7985 8.50586 6.5815ZM8.00586 9C7.59236 9 7.25586 8.6635 7.25586 8.25C7.25586 7.8365 7.59236 7.5 8.00586 7.5C8.41936 7.5 8.75586 7.8365 8.75586 8.25C8.75586 8.6635 8.41936 9 8.00586 9Z",
    fill: "#808080"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.d1c849ccd4b429cdfc0cb61202332a6e.svg";
export { ForwardRef as ReactComponent };